export default "__VITE_ASSET__Cyh4DN5l__"